import $ from 'jquery';
import barba from '@barba/core';
//import {createPopper} from '@popperjs/core';
import 'bootstrap';
import {gsap} from "gsap";
import menu from './utils/menu';
import modal from './utils/modal';
import common from './utils/common';
import transitions from './utils/transitions';
import scroll from './utils/scroll';
import createSwiper from './utils/swiper';

import landing from './pages/landing';

export const mobile = {state: false};
const _no_scroll = false;


window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

$(document).ready(function () {


    // Initialisation de common
    common.init();

    // Initialisation de connexion
    //connexion.init();

    // Contrôle de la largeur de la fenêtre
    common.getWINDOW();
    if (common.$windowW < 768) {
        mobile.state = true;
    } else {
        mobile.state = false;
    }

    // Initialisation de menu
    menu.init();

    // Initialisation du scroll
    scroll.show();

    // Initialisation du modal
    modal.init();

    document.addEventListener('click', (event) => {
        const el = event.target.closest('a.prevent-barba'); // Vérifie si un lien avec la classe est cliqué
        if (el) {
            event.preventDefault(); // Empêche le comportement par défaut

            if (el.href.startsWith('mailto:')) {
                // Laisse le mailto fonctionner sans remonter en haut de la page
                window.location.href = el.href;
            } else if (el.target === '_blank') {
                // Ouvre le lien dans une nouvelle fenêtre ou un nouvel onglet
                window.open(el.href, '_blank', 'noopener');
            } else {
                // Ouvre le lien normalement dans la même fenêtre
                window.location.href = el.href;
            }

            return false; // Bloque toute propagation supplémentaire
        }
    });


    // Configuration de Barba.js
    barba.init({
        prevent: ({el}) => el.classList && el.classList.contains('no-barba'),
        views: [
            {
                namespace: 'landing',
                afterEnter() {
                    scroll.update();
                    landing.init();
                }
            }
        ],
        transitions: [
            transitions.basicTransition
        ],
        debug: true // Ajouté pour faciliter le débogage si nécessaire
    });


    // Gestion de la redimension de la fenêtre
    $(window).on("debouncedresize", function () {
        common.getWINDOW();
        if (common.$windowW <= 768 && mobile.state === false) {
            location.reload();
            mobile.state = true;
        } else if (common.$windowW > 768 && mobile.state === true) {
            location.reload();
            mobile.state = false;
        }
    });
});
